import React, { useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useMemory } from 'hooks';
import * as ProjectActions from 'store/project/projectSlice';
import * as OrderActions from 'store/order/orderSlice';

export default function PageTabs({
  headTitle,
  headMetaDescription,
  headSchema,
  checklist,
  checklistTabs
}) {
  const {hasMemoryValue, getMemoryValue} = useMemory();
  const {pathname} = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const locationPaths = pathname.split(/\//gi);
    const locationPathLast = locationPaths[locationPaths.length - 1];
    const locationPathTab = checklistTabs.find(tab => tab.link === locationPathLast);
    const locationPathTabCode = hasMemoryValue('appProjectTabs')
      ? getMemoryValue('appProjectTabs')
      : (locationPathTab?.code || '');
    const locationPathTabId = hasMemoryValue('appProjectTabs')
      ? checklistTabs.find(tab => tab.code === getMemoryValue('appProjectTabs'))?.id
      : (locationPathTab?.id || 1);

    dispatch(ProjectActions.setProjectTypeHash(locationPathTabCode));
    dispatch(ProjectActions.setChecklist(checklist[locationPathTabId]));
    dispatch(OrderActions.resetOrder());

    const changeHeadTitleDescription = () => {
      let curHeadTitle;
      let curHeadMetaDescription;
      let curHeadSchema;

      if (checklistTabs.length > 0) {
        curHeadTitle = (checklistTabs.find(tab => tab.id === locationPathTabId)).headTitle;
        curHeadMetaDescription = (checklistTabs.find(tab => tab.id === locationPathTabId)).headMetaDescription;
        curHeadSchema = (checklistTabs.find(tab => tab.id === locationPathTabId)).headSchema;
      } else {
        curHeadTitle = headTitle;
        curHeadMetaDescription = headMetaDescription;
        curHeadSchema = headSchema;
      }

      document.title = curHeadTitle;

      const metas = document.getElementsByTagName('meta');
      const scripts = document.getElementsByTagName('script');

      for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === 'description') {
          metas[i].setAttribute('content', curHeadMetaDescription);
        }
        if (metas[i].getAttribute('property') === 'og:title'){
          metas[i].setAttribute('content', curHeadTitle);
        }
        if (metas[i].getAttribute('property') === 'og:description'){
          metas[i].setAttribute('content', curHeadMetaDescription);
        }
        if (metas[i].getAttribute('property') === 'og:url'){
          metas[i].setAttribute('content', window.location.href);
        }
        if (metas[i].getAttribute('name') === 'twitter:title'){
          metas[i].setAttribute('content', curHeadTitle);
        }
        if (metas[i].getAttribute('name') === 'twitter:description'){
          metas[i].setAttribute('content', curHeadMetaDescription);
        }
      }

      for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].getAttribute('type') === 'application/ld+json') {
          if (curHeadSchema === undefined) {
            scripts[i].innerHTML = '';
          } else {
            scripts[i].innerHTML = curHeadSchema;
          }
        }
      }
    };

    changeHeadTitleDescription();

  }, [pathname]);

  return (
    <>
      {checklistTabs.length > 0 && (
        <nav className="app-container">
          <ul className="app-tabs">
            {checklistTabs.map((checklistTab) => (
              <li key={checklistTab.id} className={`app-tab-item ${pathname.includes(checklistTab.link) ? 'active': ''}`}>
                <NavLink
                  className="app-tab-item-link"
                  key={checklistTab.id}
                  to={checklistTab.link}>
                  {checklistTab.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </>
  )
}
